import classNames from 'classnames';

type InfoContactoProps = {
	readonly className?: string;
	readonly email: string;
	readonly phone: string;
};

const classNameComponent = 'c-cnm-info-contacto';

export const InfoContacto = ({ className, email, phone }: InfoContactoProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	return (
		<div className={wrapperClassName}>
			<h3 className={`${classNameComponent}__title`}>Contacto</h3>
			<div className={`${classNameComponent}__content`}>
				<span className={`${classNameComponent}__text`}>{email}</span>
				<span className={`${classNameComponent}__text`}>{phone}</span>
			</div>
		</div>
	);
};
